import { Component, OnInit, OnDestroy } from '@angular/core';
import { CurrentPageWatcherService } from '../CurrentPageWatcher';
import { ContentPageModel, StringWithHyperlinkParametersModel } from '../../../model/models';
import { Subscription } from 'rxjs';
import { SectionContentModel } from '../../../model/sectionContentModel';
import { SectionTextModel } from '../../../model/sectionTextModel';

@Component({
  selector: 'app-step-message',
  templateUrl: './step-message-content.component.html',
  styleUrls: ['./step-message-content.component.css']
})
export class StepMessageContentComponent implements OnInit, OnDestroy {
 

   stepMessageContent : ContentPageModel = {};
   headerContent : string = "";
   headerContentSubscription : Subscription;
   lastStep : boolean =false;
    constructor( private currentPageWatcher: CurrentPageWatcherService) {

      this.lastStep = this.currentPageWatcher.lastStep;

     this.currentPageWatcher.getStepMessage().subscribe((stepMessage : ContentPageModel)=>{
        console.log("step message : ", stepMessage);
        if(stepMessage==null){
          this.stepMessageContent=null;
        }
        if(stepMessage!=null){
          this.stepMessageContent= stepMessage;
  
        }
      });

      
  
    
    }

  ngOnInit() {
    
 
  }
  mapStringWithHyperlinkParameters(header: StringWithHyperlinkParametersModel) {

    let text = header.StringContent;
    let contentModel : SectionContentModel=new SectionContentModel();
    if (header.Hyperlinks.length != 0) {

      for (let i = 0; i < header.Hyperlinks.length; i++) {
        let headerSectionText = new SectionTextModel();
        let str: string = "{" + i + "}";
        headerSectionText.text = text.split(str)[0];
        let strToReplace: string = text.split(str)[0] + str;
        text = text.replace(strToReplace, "");
        headerSectionText.link = header.Hyperlinks[i].LinkText;
        headerSectionText.href = header.Hyperlinks[i].Href;

        contentModel.textList.push(headerSectionText);
      }
      if(text){
        let sectionTextModel = new SectionTextModel();
        sectionTextModel.text=text;
        contentModel.textList.push(sectionTextModel)
      }
    }
    if (header.Hyperlinks.length == 0){
      let headerSectionText = new SectionTextModel();
      headerSectionText.text = header.StringContent;
      contentModel.textList.push(headerSectionText);
    }
    return contentModel;
  }
  ngOnDestroy(): void {
    this.currentPageWatcher.clearStepMessage();
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/utils/step-message-content/step-message-content.component.ts